export class BaseFile extends File {

}
